var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-header'),_c('div',{staticClass:"fill",attrs:{"id":"App","data-app":"true"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('app-footer'),_c('version-released')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }